"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKGROUND_MESH = exports.WINDOW_TEXTURE_MESH = exports.DOOR_TEXTURE_MESH = exports.KITCHEN_CABINET_COUNTERTOP_MESH = exports.KITCHEN_CABINET_TEXTURE_MESH = void 0;
exports.detectMeshFeatures = detectMeshFeatures;
exports.KITCHEN_CABINET_TEXTURE_MESH = '$$kitchen-cabinet-texture';
exports.KITCHEN_CABINET_COUNTERTOP_MESH = '$$kitchen-cabinet-countertop';
exports.DOOR_TEXTURE_MESH = '$$door-texture';
exports.WINDOW_TEXTURE_MESH = '$$window-texture';
exports.BACKGROUND_MESH = '$$background';
/**
 * Scans a parsed Babylon JSON for the mesh-name traits the catalog/runtime
 * pipeline cares about (cabinet/countertop/door texture targets and the
 * `$$background` see-through marker used by the new windows).
 */
function detectMeshFeatures(babylonJson) {
    var _a;
    const parsed = typeof babylonJson === 'string'
        ? JSON.parse(babylonJson)
        : babylonJson;
    const meshes = (_a = parsed === null || parsed === void 0 ? void 0 : parsed.meshes) !== null && _a !== void 0 ? _a : [];
    let hasCabinetTexture = false;
    let hasCabinetCountertop = false;
    let hasDoorTexture = false;
    let hasWindowTexture = false;
    let hasBackground = false;
    for (const mesh of meshes) {
        const name = mesh === null || mesh === void 0 ? void 0 : mesh.name;
        if (typeof name !== 'string')
            continue;
        if (name.startsWith(exports.KITCHEN_CABINET_TEXTURE_MESH))
            hasCabinetTexture = true;
        if (name.startsWith(exports.KITCHEN_CABINET_COUNTERTOP_MESH))
            hasCabinetCountertop = true;
        if (name.startsWith(exports.DOOR_TEXTURE_MESH))
            hasDoorTexture = true;
        if (name.startsWith(exports.WINDOW_TEXTURE_MESH))
            hasWindowTexture = true;
        if (name.startsWith(exports.BACKGROUND_MESH))
            hasBackground = true;
    }
    return { hasCabinetTexture, hasCabinetCountertop, hasDoorTexture, hasWindowTexture, hasBackground };
}
